import React from 'react'

function IconWrapper(props) {
  const {
    children, className, isLeft, isRight, isSmall, isMedium, isLarge, ...rest
  } = props

  const classes = [
    'icon',
    isSmall ? 'is-small' : '',
    isMedium ? 'is-medium' : '',
    isLarge ? 'is-large' : '',
    isLeft ? 'is-left' : '',
    isRight ? 'is-right' : '',
    className || '',
  ]

  return (
    <span {...rest} className={classes.join(' ')}>{children}</span>
  )
}

export default IconWrapper
